import { TFunction } from 'react-i18next';

import { SelectItemData } from '@swyftx/aviary/atoms/Select';
import { MarginOrderStatus } from '@swyftx/margin/build/types';

import { MarginHistoryDirection } from 'src/lib/margin/types';

export type MarginHistoryTableData = {
  instrument: string;
  type: string;
  side: string;
  actionEvent: string;
  lots: string;
  price: string;
  profitLoss: string;
  commission: string;
  lastUpdated: string;
  orderId: string;

  // Mobile View
  instrumentSide: string;
  mobilePrice: string;
  mobileProfitLoss: string;
  lotsProfitLoss: string;
};

export const marginHistoryDirections: SelectItemData<MarginHistoryDirection>[] = [
  {
    label: 'Buy (long)',
    value: 'BUY',
  },
  {
    label: 'Sell (short)',
    value: 'SELL',
  },
];

export const marginHistoryEvents = (t: TFunction<'margin'>): SelectItemData<string>[] =>
  Object.values(MarginOrderStatus).map((value: string) => ({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    label: t(`tradeStatus.${value}` as any),
    value,
  }));
